import {accountApi} from '../api/accountApi';
import clubApi from '../../club/api/clubApi';

export const login = (email, password, onError) => (dispatch) => {
    accountApi.login(email, password).then((response) => {
        if (response.data.success) {
            window.sessionStorage.setItem('api-key', response.data.result.apiKey);
            accountApi.findMe().then((res) => {
                    if (response.data.success) {
                        getAllClubs(dispatch);
                    }
                    setAccount(dispatch, res.data.success ? res.data.result : null);
                }
            );
        } else {
            if (onError) {
                onError(response);
            }
        }
    });
};

export const checkState = () => (dispatch) => {
    accountApi.checkState().then((response) => {
        if (response.data.success) {
            getAllClubs(dispatch);
        }
        setAccount(dispatch, response.data.success ? response.data.result : null);
    });
};

export const loadClubs = () => (dispatch) => {
    getAllClubs(dispatch);
};

function getAllClubs(dispatch) {
    clubApi.findAll().then((response) => {
        dispatch({
            type: 'SET_CLUBS',
            data: response.data.success ? response.data.result : null
        });
    });
}

export const updateAccount = (account) => (dispatch) => {
    setAccount(dispatch, account);
};

function setAccount(dispatch, account) {
    dispatch({
        type: 'SET_ACCOUNT',
        data: account
    });
    // dispatch({
    //     type: 'SET_CLUB',
    //     data: account?.club
    // });
}
